import React from "react";
import Item from "./item";
import styles from "./index.module.less";

class ArticleKinds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { data = [], category, source } = this.props;

    if (data.length === 0) {
      return null;
    }
    return (
      <section className={styles["ArticleKinds"]}>
        <div className='flex items-center justify-between flex-wrap mb-10'>
          <h2>相關&競爭車款</h2>
        </div>
        <div className={styles["content"]}>
          {data.map((v, i) => (
            <React.Fragment key={i}>{i < 3 && <Item data={v} category={category} source={source} />}</React.Fragment>
          ))}
        </div>
      </section>
    );
  }
}

export default ArticleKinds;
